import { toast } from "react-toastify";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideNotification } from "@/legacy/redux";
import { useTranslation } from "react-i18next";

/**
 * @deprecated only gets called by old immi platform code
 * A utility hook to show and hide notifications on the stack.
 */
export const useLegacyNotification = () => {
  const dispatch = useDispatch();
  // @ts-ignore
  const notification = useSelector((state) => state.notification[0]);

  const hide = () => {
    dispatch(hideNotification());
  };

  return {
    notification,
    hide,
  };
};

/** 
 * @deprecated only gets called by old immi platform code
 * Component that binds legacy platform notifications into latest toast system
 */
export const ImmiNotifications = () => {
  const { notification, hide } = useLegacyNotification();
  const { t } = useTranslation();

  useEffect(() => {
    if(!!notification) {
      // we have a notification to process
      const { message, type, messageArgs } = notification;
      const duration = messageArgs?.smart_count ?? 3000;
      toast(t(message, messageArgs), { autoClose: duration, type, onClose: hide });
    }
  }, [hide, notification, t]);

  return null;
};

const makeToast = (
  msg: string,
  level: "info" | "warning" | "error" = "info",
  duration: number | undefined = undefined,
) => {
  toast(msg, { autoClose: duration, type: level });
};

makeToast.info = (msg: string, duration?: number) => {
  console.log(`[Notify] ${msg} (info)`);
  toast.info(msg, { autoClose: duration });
};
makeToast.success = (msg: string, duration?: number) => {
  console.log(`[Notify] ${msg} (success)`);
  toast.success(msg, { autoClose: duration });
};
makeToast.warning = (msg: string, duration?: number) => {
  console.log(`[Notify] ${msg} (warning)`);
  toast.warning(msg, { autoClose: duration });
};
makeToast.error = (msg: string, duration?: number) => {
  console.log(`[Notify] ${msg} (error)`);
  toast.error(msg, { autoClose: duration });
};
makeToast.promise = toast.promise;
makeToast.loading = toast.loading;
makeToast.update = toast.update;
makeToast.dismiss = toast.dismiss;

export const useNotification = () => makeToast;

// Re-export of useNotification to match more modern naming conventions
export const useNotify = useNotification;
// re-export toast for use in other parts of the app under a similar name
export const notify = toast;
